new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if(bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if(bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    } 

    const faixCupom = document.querySelector('.faixa-cupom');
    if(faixCupom) {
        const formButton = document.querySelector('.faixa-cupom-form button');
        var inputElement = document.getElementById("valorParaCopiar");
        if(inputElement) {
            var newValueInput = inputElement.value.replace(/^\/\//, '');
            inputElement.value = newValueInput
        
            if(formButton) {
                formButton.addEventListener("click", (e) => {
                    e.preventDefault();

                    inputElement.select();

                    document.execCommand("copy");

                    window.getSelection().removeAllRanges();

                    alert("Valor copiado: " + newValueInput);
                });
            }
        }
    }

    waitForElementToExist('.banner-instagram').then(element => {
        $('#js-carrousel-instagram').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1500,
            slidesToShow: 2,
            slidesToScroll: 2,
        });
    });

    waitForElementToExist('.categories').then(element => {
        $('#categories-home-carrousel').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            infinite: false,
            autoplay: false,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if(firstCarrousel) {
            $('#product_list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondVitrine = element.querySelector('#product_list2');
        if(secondVitrine) {
            $('#product_list2').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });
    
    waitForElementToExist('.lateral-banners').then(element => {
        $('.lateral-banners-carousel').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows       : false,
            dots         : false,
            infinite     : true,
            slidesToShow : 1,
            slidesToScroll : 1,
            speed        : 100,
            mobileFirst: true,
            responsive: [
                { 
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                { 
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                { 
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                { 
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        const faixaComunicado = element.querySelector('.faixa-comunicado-content');
        if(faixaComunicado) {
            $('.faixa-comunicado-content').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: 'unslick'
                    }
                ]
            });
        }
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".group-arrow .group-arrow-prev"),
                nextArrow: $(".group-arrow .group-arrow-next"),
                dots: true,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                            adaptiveHeight: true,
                        }
                    },
                    {
                        breakpoint: 1270,
                        settings: {
                            slidesToShow: 4,
                            slidesToShow: 4,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });
    
});